module.exports = __webpack_public_path__ + "img/xueyuan-qrcode.9aa51bd3.png";